import React from 'react'
import { Form, Input } from 'antd'
import { MobileOutlined } from '@ant-design/icons';
import CaptchaMsg from "./CaptchaMsg";


export default function MessageCodeCheck(props) {
    const { btnDisabled, btnText, sendMessage } = props

    return (
        <div>
            <Form.Item
                name="Phone"
            >
                <Input prefix={<MobileOutlined className="site-form-item-icon" />} placeholder="手机号" disabled={true}/>
            </Form.Item>
            <CaptchaMsg btnDisabled={btnDisabled} btnText={btnText} sendMessage={sendMessage}/>
        </div>
    )
}
